"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SskyCognitoService = void 0;
const amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
const authService_1 = require("../authService");
const errors_1 = require("../errors");
const utils_1 = require("../utils");
class SskyCognitoService {
    constructor(config) {
        this.userPool = new amazon_cognito_identity_js_1.CognitoUserPool(config);
        this.CognitoUser = this.userPool.getCurrentUser();
        this.identityPoolId = config.IdentityPoolId;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.CognitoUser) {
                return new Promise((resolve) => {
                    this.CognitoUser.getSession((err, result) => __awaiter(this, void 0, void 0, function* () {
                        if (result) {
                            try {
                                this.jwtIdToken = result.getIdToken().getJwtToken();
                                resolve();
                            }
                            catch (err) {
                                // ignore
                                resolve();
                            }
                        }
                        else {
                            resolve();
                        }
                    }));
                });
            }
        });
    }
    isFirstLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    isUserDeactivated() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    login(user, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const normalizedUsername = (0, utils_1.normalizeUsername)(user);
            const authenticationData = {
                Username: normalizedUsername,
                Password: password
            };
            const authenticationDetails = new amazon_cognito_identity_js_1.AuthenticationDetails(authenticationData);
            const cognitoUser = this._getCognitoUser(normalizedUsername);
            return new Promise((resolve, reject) => {
                cognitoUser.authenticateUser(authenticationDetails, {
                    onSuccess: (result) => {
                        this.jwtIdToken = result.getIdToken().getJwtToken();
                        resolve();
                    },
                    onFailure: reject,
                    newPasswordRequired: () => {
                        reject(errors_1.errors.newPasswordRequired);
                    }
                });
            });
        });
    }
    loginWithRedirect() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    loginWithPopup() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            (_a = this.CognitoUser) === null || _a === void 0 ? void 0 : _a.signOut();
        });
    }
    isUserManaged() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    getUserAccessToken() {
        return new Promise((resolve, reject) => {
            let cognitoUser = this._getCognitoUser();
            if (!cognitoUser) {
                resolve("");
            }
            else {
                cognitoUser.getSession((err, session) => {
                    if (err) {
                        reject(errors_1.errors.userNotLoggedIn);
                    }
                    else {
                        resolve(session.getAccessToken().getJwtToken());
                    }
                });
            }
        });
    }
    getUserIdToken() {
        return new Promise((resolve, reject) => {
            const cognitoUser = this._getCognitoUser();
            if (!cognitoUser) {
                resolve("");
            }
            else {
                cognitoUser.getSession((err, session) => __awaiter(this, void 0, void 0, function* () {
                    if (err) {
                        reject(errors_1.errors.userNotLoggedIn);
                    }
                    else {
                        const jwtToken = session.getIdToken().getJwtToken();
                        resolve(jwtToken);
                    }
                }));
            }
        });
    }
    getUserName() {
        var _a;
        return (_a = this.CognitoUser) === null || _a === void 0 ? void 0 : _a.getUsername();
    }
    initiateForgotPassword(username) {
        const usernameLowerCase = username.toLowerCase();
        return new Promise((resolve, reject) => {
            this._getCognitoUser(usernameLowerCase).forgotPassword({
                onSuccess: resolve,
                onFailure: reject
            });
        });
    }
    confirmForgotPassword(username, verificationCode, newPassword) {
        return new Promise((resolve, reject) => {
            this._getCognitoUser(username.toLowerCase()).confirmPassword(verificationCode.trim(), newPassword, {
                onSuccess: resolve,
                onFailure: reject
            });
        });
    }
    changePassword(user, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._completeNewPasswordChallenge(user, newPassword);
            yield this.login(user, newPassword);
        });
    }
    _completeNewPasswordChallenge(username, newPassword) {
        return new Promise((resolve, reject) => {
            const userAttributes = { name: username.toLowerCase() };
            this._getCognitoUser().completeNewPasswordChallenge(newPassword, userAttributes, {
                onSuccess: () => resolve(),
                onFailure: reject
            });
        });
    }
    _changePassword(user, oldPassword, newPassword) {
        let userName = user.toLowerCase();
        return new Promise((resolve, reject) => {
            let cognitoUser = this._getCognitoUser(userName);
            let authenticatedUserPromise;
            // @ts-ignore
            if (cognitoUser.Session) {
                authenticatedUserPromise = Promise.resolve();
            }
            else {
                authenticatedUserPromise = this.login(userName, oldPassword);
            }
            authenticatedUserPromise.then(() => {
                cognitoUser.changePassword(oldPassword, newPassword, (err) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                });
            }).catch(reject);
        });
    }
    _getCognitoUser(user) {
        var _a, _b;
        let userName = (_a = user === null || user === void 0 ? void 0 : user.toLowerCase()) !== null && _a !== void 0 ? _a : null;
        if (userName && (((_b = this.CognitoUser) === null || _b === void 0 ? void 0 : _b.getUsername()) !== userName)) {
            const userData = {
                Username: userName.toLowerCase(),
                Pool: this.userPool
            };
            this.CognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
        }
        return this.CognitoUser;
    }
    subscribe(callback) {
        // TODO subscribe to state changes
        return;
    }
    getAuthServiceType() {
        return authService_1.AuthServiceType.COGNITO;
    }
}
exports.SskyCognitoService = SskyCognitoService;
//# sourceMappingURL=SskyCognitoService.js.map